/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SharedContactDealerWrapper_user$ref = any;
export type SharedContactDealerWrapper_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": SharedContactDealerWrapper_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedContactDealerWrapper_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'ed3b236b1f1d92ed75de332348a5887d';
export default node;
